
















import {Component, Watch, Prop, Vue} from 'vue-property-decorator'
import { PageCollection } from 'simpli-web-sdk'
import SacResponse from '@/model/response/SacResponse'
import { SacType } from '../../enums/SacType'

@Component
export default class ItTrackingSlider extends Vue {
  @Prop({type: Object, required: true}) collection!: PageCollection<SacResponse>

  get lastAttemptItems() {
    const lastAttemptIndex = this.collection.items
      .reduce((index: Number, item: SacResponse) => {
        if (item === null || item.attempt === null) {
          return index
        }

        if (item.attempt > index) {
          index = item.attempt
        }
        return index
      }, 0)

    return this.collection.items
      .filter((item) =>
        item.attempt === lastAttemptIndex &&
        item.type !== SacType.TRACKING)
  }
}
